module.exports = __webpack_public_path__ + "static/engineering-52bc88f08df2d17e2f22769a0f384cbc.jpg";